import React from 'react';
import { THEME } from '../../../themes';
import { PerfectSkeletonProps } from './perfect-skeleton';
import { SkeletonContainer } from './perfect-skeleton.styled';

export const PerfectSkeleton = ({
  width,
  height,
  variant = 'rectangular',
}: PerfectSkeletonProps): JSX.Element => {
  const getVariantProps = () => {
    switch (variant) {
      case 'circular':
        return {
          width: width || height || 40,
          height: height || width || 40,
          isCircular: true,
          borderRadius: undefined,
        };
      case 'text':
        return {
          width: width || '100%',
          height: height || '1em',
          isCircular: false,
          borderRadius: THEME.RADIUS.NANO,
        };
      case 'rounded':
        return {
          width: width || 100,
          height: height || 20,
          isCircular: false,
          borderRadius: THEME.RADIUS.BASE,
        };
      case 'rectangular':
      default:
        return {
          width: width || 100,
          height: height || 20,
          isCircular: false,
          borderRadius: THEME.RADIUS.TIDY,
        };
    }
  };

  const variantProps = getVariantProps();

  return (
    <SkeletonContainer
      $width={ variantProps.width }
      $height={ variantProps.height }
      $isCircular={ variantProps.isCircular }
      $borderRadius={ variantProps.borderRadius }
    />
  );
};
